<template>
  <a href="/" class="flex items-center">
<!--    <img v-if="$route.name === 'app_home'" src="../assets/logo-deglingo.png" class="mr-3 h-24 lg:h-48" alt="Flowbite Logo" />-->
<!--    <img v-else src="../assets/logo-deglingo.svg" class="mr-3 h-24" alt="Flowbite Logo" />-->
    <h1 :class="`font-extrabold text-4xl ${color}`">𐌃𐌄Ᏽ𐌋𐌉𐌍ᏵØ</h1>
  </a>
</template>

<script>
export default {
  name: 'LogoApp',
  props: {
    color: {
      type: String,
      default: 'text-primary-700'
    }
  }
}
</script>